export default __webpack_public_path__ + "static/media/AnyConv.com__Inter-Regular.4058c766.ttf";